import filterFunctions from 'js/constants/filterFunctions';
import {
  RECIPE_GROUP_FILTERS,
  TransformParameterTypes,
  FilterTypesKeys,
} from 'js/constants/schemaEditor';
import TransformDSLParser from './TransformDSLParser';
import TransformsUtils from './TransformsUtils';

const filterFunctionsByName = filterFunctions.reduce(
  (acc, func) => {
    acc[func.value] = func;
    return acc;
  },
  {} as Record<string, any>,
);

const parse = (input: string) => {
  const parsed = TransformDSLParser.parse(input, null, filterFunctionsByName);

  // convert transform AST to filter AST
  let filterAST = convertTransformASTToFilterAST(parsed);
  filterAST = Array.isArray(filterAST) ? filterAST : [filterAST];
  const tx = TransformsUtils.getTxFromRecipe([
    {
      type: RECIPE_GROUP_FILTERS,
      data: [
        {
          type: TransformParameterTypes.FILTER_GROUP,
          parameters: filterAST,
        },
      ],
    },
  ]);
  const filterSpec = tx.txObject.transforms?.find(
    ({ operation }) => operation === 'nexla.filter',
  )?.spec;

  return {
    filterExpression: filterSpec.filter,
    filterAST,
  };
};

const convertTransformASTToFilterAST = (ast: any) => {
  const { type, name, parameters } = ast;

  if (type !== 'function') {
    return ast;
  }

  // Handle logical operators (and?, or?)
  if (name === 'and?' || name === 'or?') {
    const result: any[] = [];

    parameters.forEach?.((param: any, index: number) => {
      if (param.type === 'function') {
        result.push(convertTransformASTToFilterAST(param));
      }

      if (index < parameters.length - 1) {
        result.push({
          type: 'ruleJoinOp',
          value: name === 'and?' ? '&&' : '||',
        });
      }
    });

    return result;
  }

  return convertComparisonToFilterRule(ast);
};

const convertComparisonToFilterRule = (ast: any) => {
  const { name, parameters } = ast;
  // for IsNull/IsNotNull/InRecord/NotInRecord, the second arg should be null
  let ruleVal = [
    FilterTypesKeys.FILTER_IS_NULL,
    FilterTypesKeys.FILTER_NOT_NULL,
    FilterTypesKeys.FILTER_IS_PRESENT,
    FilterTypesKeys.FILTER_IS_NOT_PRESENT,
  ].includes(name)
    ? { type: 'nullValue', value: null }
    : parameters.withAttr;

  if (ruleVal?.type === 'number') {
    ruleVal = {
      ...ruleVal,
      value: Number(ruleVal.value),
    };
  }

  return {
    type: 'filterRule',
    ruleOp: name,
    ruleVal,
    ruleAttribute: parameters.value?.name || '',
  };
};

export default { parse };
